import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ROOT } from "../paths";
import { clearLogoutInitiated, markLoginRequiredAfterLogout } from "./logoutState";

const LogoutCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    clearLogoutInitiated();
    markLoginRequiredAfterLogout();
    navigate(ROOT, { replace: true });
  }, [navigate]);

  return null;
};

export default LogoutCallback;
